    let players;

    const initPlayersSlider = () => {
        players = new Swiper('.players-list .swiper-container', {
          slidesPerView: 5,
          spaceBetween: 20,
          effect: 'slide',
          loop: true,
          breakpoints: {
              320: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              480: {
                slidesPerView: 2,
                spaceBetween: 20
              },
              540: {
                slidesPerView: 2,
                spaceBetween: 30
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 30
              },
              1280: {
                slidesPerView: 4,
                spaceBetween: 20
              }
          }
        });
    }
  
    const destroyPlayersSlider = () => {
      if (players !== undefined) {
        players.destroy(true, true);
      }
    };

    document.addEventListener('DOMContentLoaded', function () {
        if(players){
          destroyPlayersSlider();
        }
        initPlayersSlider();
      
    });
